import { useState } from "react";
import { ADOPT_NOTICES_KEY } from "../emulator/profiles";

function read(): string[] {
  try {
    return JSON.parse(localStorage.getItem(ADOPT_NOTICES_KEY) ?? "[]") as string[];
  } catch {
    return [];
  }
}

/**
 * What adopting signed-out saves at sign-in did (profiles.ts): a state moved
 * to another slot, or kept back. On every page, the player included, until
 * dismissed.
 */
export default function AdoptedSaves() {
  const [notices, setNotices] = useState(read);
  if (!notices.length) return null;
  return (
    <div className="notice" role="status" style={{ position: "fixed", left: 16, right: 16, bottom: 16, zIndex: 1000, maxWidth: 560, margin: "0 auto" }}>
      {notices.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
      <button
        type="button"
        className="btn"
        onClick={() => {
          localStorage.removeItem(ADOPT_NOTICES_KEY);
          setNotices([]);
        }}
      >
        OK
      </button>
    </div>
  );
}
